import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import EditorViewer from "@/components/pageEditor/EditorViewer.vue";
import { D2 } from "@terrastruct/d2";
import { injectD2DiagramThemeAndClasses } from "@/util/d2Util";
import IconButton from "@/components/buttons/IconButton.vue";
import PanZoomViewer from "@/components/panZoomViewer/PanZoomViewer.vue";
let DiagramChapterViewer = class DiagramChapterViewer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "diagramD2Code", void 0);
    _defineProperty(this, "d2", new D2());
    _defineProperty(this, "diagramSVG", '');
  }
  mounted() {
    this.applyDiagramOutput(this.diagramD2Code);
  }
  async applyDiagramOutput(d2Code) {
    if (!d2Code?.trim()) {
      this.diagramSVG = '';
      return;
    }
    const codeWithTheme = injectD2DiagramThemeAndClasses(d2Code);
    const result = await this.d2.compile(codeWithTheme, {
      center: true
    });
    this.diagramSVG = await this.d2.render(result.diagram, result.renderOptions);
  }
};
__decorate([Prop({
  required: true
})], DiagramChapterViewer.prototype, "diagramD2Code", void 0);
DiagramChapterViewer = __decorate([Component({
  components: {
    PanZoomViewer,
    IconButton,
    EditorViewer
  }
})], DiagramChapterViewer);
export default DiagramChapterViewer;